import { fetcher } from '@/lib/fetcher';

export const fetchRegisterUtm = (data: { [key: string]: string | number }) => {
    return fetcher<unknown, { [key: string]: string | number }>({
        url: '/user/v1/me/utmupdate',
        method: 'PUT',
        data
    });
};
